// Version : 1.0.0
// Author : AGALYA

import AdvanceMemberActionType from './advance-member.types';

/** ***************** FETCH ADVANCE MEMBER LIST START *********************** */
export const fetchAdvanceMemberListStart = (Credentils: any) => ({
	type: AdvanceMemberActionType.FETCH_ADVANCE_MEMBER_LIST_START,
	payload: Credentils,
});

export const fetchAdvanceMemberListSuccess = (Credentils: any) => ({
	type: AdvanceMemberActionType.FETCH_ADVANCE_MEMBER_LIST_SUCCESS,
	payload: Credentils,
});

export const fetchAdvanceMemberListFailure = (error: any) => ({
	type: AdvanceMemberActionType.FETCH_ADVANCE_MEMBER_LIST_FAILURE,
	payload: error,
});

export const fetchAdvanceMemberListResponseResetStart = () => ({
	type: AdvanceMemberActionType.FETCH_ADVANCE_MEMBER_LIST_RESPONSE_REST_START,
});

export const fetchAdvanceMemberListResponseChanged = () => ({
	type: AdvanceMemberActionType.FETCH_ADVANCE_MEMBER_LIST_RESPONSE_CHANGED,
});
/** ***************** FETCH ADVANCE MEMBER LIST END *********************** */
